import { render, staticRenderFns } from "./updatePTCF.vue?vue&type=template&id=5bff516e&lang=pug&"
import script from "./updatePTCF.vue?vue&type=script&lang=js&"
export * from "./updatePTCF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports